import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAll () {
    return axios.post(global.BASE_INFO + '/org/findAllOrgs')
  },
  findAllByString (params) {
    return axios.post(global.BASE_INFO + '/org/findAllOrgs', params)
  },
  orgfindByParentCode (params) {
    return axios.post(global.BASE_INFO + '/org/findByParentCode', params)
  },
  orgDeleteByCode (params) {
    return axios.post(global.BASE_INFO + '/org/deleteOrgByCode', params)
  },
  orgResumeByCode (params) {
    return axios.post(global.BASE_INFO + '/org/resumeOrgByCode', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/org/orgList.js